import type { ObjectSchemaDefinition } from '@axinom/mosaic-ui';
import * as Yup from 'yup';

/** Container names must start or end with a letter or number,
 * and can contain only letters, numbers, and the dash (-) character.
 * Every dash (-) character must be immediately preceded and followed by a letter or number;
 * consecutive dashes are not permitted in container names */
const containerNameRegex = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');

const containerNameMinLength = 3;
const containerNameMaxLength = 63;

const nameLengthRangeValidationErrorMessage = `Name must be between ${containerNameMinLength} and ${containerNameMaxLength} characters in length`;

export const containerCreateSchema = Yup.object<ObjectSchemaDefinition>({
  name: Yup.string()
    .strict()
    .required('Name is a required field')
    .lowercase('All letters in a container name must be lowercase')
    .min(containerNameMinLength, nameLengthRangeValidationErrorMessage)
    .max(containerNameMaxLength, nameLengthRangeValidationErrorMessage)
    .matches(
      containerNameRegex,
      `Name must start or end with a letter or number and can contain only letters, numbers, and the dash (-) character. 
      Every dash (-) character must be immediately preceded and followed by a letter or number.`,
    ),
});
